/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface CampaignOverview
 */
export interface CampaignOverview {
    /**
     * 
     * @type {MoneyOutput}
     * @memberof CampaignOverview
     */
    cpa?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof CampaignOverview
     */
    cpm?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof CampaignOverview
     */
    cpc?: MoneyOutput;
    /**
     * 
     * @type {number}
     * @memberof CampaignOverview
     */
    pnoNet?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignOverview
     */
    pnoGross?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignOverview
     */
    roasNet?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignOverview
     */
    roasGross?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignOverview
     */
    poasNet?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignOverview
     */
    poasGross?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignOverview
     */
    poasBeforeMarketingNet?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignOverview
     */
    poasBeforeMarketingGross?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignOverview
     */
    ctr?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignOverview
     */
    conversionRateNet?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignOverview
     */
    conversionRateGross?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof CampaignOverview
     */
    profitNet?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof CampaignOverview
     */
    profitGross?: MoneyOutput;
    /**
     * 
     * @type {number}
     * @memberof CampaignOverview
     */
    profitPercentNet?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignOverview
     */
    profitPercentGross?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignOverview
     */
    unverifiedLeads?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignOverview
     */
    verifiedLeads?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignOverview
     */
    ordersNet?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignOverview
     */
    ordersGross?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof CampaignOverview
     */
    turnoverNet?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof CampaignOverview
     */
    turnoverGross?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof CampaignOverview
     */
    spendGoodsNet?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof CampaignOverview
     */
    spendGoodsGross?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof CampaignOverview
     */
    spendMarketing?: MoneyOutput;
    /**
     * 
     * @type {number}
     * @memberof CampaignOverview
     */
    clicks?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignOverview
     */
    impressions?: number;
    /**
     * 
     * @type {string}
     * @memberof CampaignOverview
     */
    remoteId?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignOverview
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignOverview
     */
    integrationName?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignOverview
     */
    statusName?: string;
    /**
     * 
     * @type {CampaignOverviewPerformanceSegmentGrossEnum}
     * @memberof CampaignOverview
     */
    performanceSegmentGross?: CampaignOverviewPerformanceSegmentGrossEnum;
    /**
     * 
     * @type {string}
     * @memberof CampaignOverview
     */
    status?: string;
}


/**
 * @export
 */
export const CampaignOverviewPerformanceSegmentGrossEnum = {
    AboveBreakEven: 'aboveBreakEven',
    Loss: 'loss',
    LowData: 'lowData'
} as const;
export type CampaignOverviewPerformanceSegmentGrossEnum = typeof CampaignOverviewPerformanceSegmentGrossEnum[keyof typeof CampaignOverviewPerformanceSegmentGrossEnum];


/**
 * Check if a given object implements the CampaignOverview interface.
 */
export function instanceOfCampaignOverview(value: object): value is CampaignOverview {
    return true;
}

export function CampaignOverviewFromJSON(json: any): CampaignOverview {
    return CampaignOverviewFromJSONTyped(json, false);
}

export function CampaignOverviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): CampaignOverview {
    if (json == null) {
        return json;
    }
    return {
        
        'cpa': json['cpa'] == null ? undefined : MoneyOutputFromJSON(json['cpa']),
        'cpm': json['cpm'] == null ? undefined : MoneyOutputFromJSON(json['cpm']),
        'cpc': json['cpc'] == null ? undefined : MoneyOutputFromJSON(json['cpc']),
        'pnoNet': json['pnoNet'] == null ? undefined : json['pnoNet'],
        'pnoGross': json['pnoGross'] == null ? undefined : json['pnoGross'],
        'roasNet': json['roasNet'] == null ? undefined : json['roasNet'],
        'roasGross': json['roasGross'] == null ? undefined : json['roasGross'],
        'poasNet': json['poasNet'] == null ? undefined : json['poasNet'],
        'poasGross': json['poasGross'] == null ? undefined : json['poasGross'],
        'poasBeforeMarketingNet': json['poasBeforeMarketingNet'] == null ? undefined : json['poasBeforeMarketingNet'],
        'poasBeforeMarketingGross': json['poasBeforeMarketingGross'] == null ? undefined : json['poasBeforeMarketingGross'],
        'ctr': json['ctr'] == null ? undefined : json['ctr'],
        'conversionRateNet': json['conversionRateNet'] == null ? undefined : json['conversionRateNet'],
        'conversionRateGross': json['conversionRateGross'] == null ? undefined : json['conversionRateGross'],
        'profitNet': json['profitNet'] == null ? undefined : MoneyOutputFromJSON(json['profitNet']),
        'profitGross': json['profitGross'] == null ? undefined : MoneyOutputFromJSON(json['profitGross']),
        'profitPercentNet': json['profitPercentNet'] == null ? undefined : json['profitPercentNet'],
        'profitPercentGross': json['profitPercentGross'] == null ? undefined : json['profitPercentGross'],
        'unverifiedLeads': json['unverifiedLeads'] == null ? undefined : json['unverifiedLeads'],
        'verifiedLeads': json['verifiedLeads'] == null ? undefined : json['verifiedLeads'],
        'ordersNet': json['ordersNet'] == null ? undefined : json['ordersNet'],
        'ordersGross': json['ordersGross'] == null ? undefined : json['ordersGross'],
        'turnoverNet': json['turnoverNet'] == null ? undefined : MoneyOutputFromJSON(json['turnoverNet']),
        'turnoverGross': json['turnoverGross'] == null ? undefined : MoneyOutputFromJSON(json['turnoverGross']),
        'spendGoodsNet': json['spendGoodsNet'] == null ? undefined : MoneyOutputFromJSON(json['spendGoodsNet']),
        'spendGoodsGross': json['spendGoodsGross'] == null ? undefined : MoneyOutputFromJSON(json['spendGoodsGross']),
        'spendMarketing': json['spendMarketing'] == null ? undefined : MoneyOutputFromJSON(json['spendMarketing']),
        'clicks': json['clicks'] == null ? undefined : json['clicks'],
        'impressions': json['impressions'] == null ? undefined : json['impressions'],
        'remoteId': json['remoteId'] == null ? undefined : json['remoteId'],
        'name': json['name'] == null ? undefined : json['name'],
        'integrationName': json['integrationName'] == null ? undefined : json['integrationName'],
        'statusName': json['statusName'] == null ? undefined : json['statusName'],
        'performanceSegmentGross': json['performanceSegmentGross'] == null ? undefined : json['performanceSegmentGross'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function CampaignOverviewToJSON(json: any): CampaignOverview {
    return CampaignOverviewToJSONTyped(json, false);
}

export function CampaignOverviewToJSONTyped(value?: CampaignOverview | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cpa': MoneyOutputToJSON(value['cpa']),
        'cpm': MoneyOutputToJSON(value['cpm']),
        'cpc': MoneyOutputToJSON(value['cpc']),
        'pnoNet': value['pnoNet'],
        'pnoGross': value['pnoGross'],
        'roasNet': value['roasNet'],
        'roasGross': value['roasGross'],
        'poasNet': value['poasNet'],
        'poasGross': value['poasGross'],
        'poasBeforeMarketingNet': value['poasBeforeMarketingNet'],
        'poasBeforeMarketingGross': value['poasBeforeMarketingGross'],
        'ctr': value['ctr'],
        'conversionRateNet': value['conversionRateNet'],
        'conversionRateGross': value['conversionRateGross'],
        'profitNet': MoneyOutputToJSON(value['profitNet']),
        'profitGross': MoneyOutputToJSON(value['profitGross']),
        'profitPercentNet': value['profitPercentNet'],
        'profitPercentGross': value['profitPercentGross'],
        'unverifiedLeads': value['unverifiedLeads'],
        'verifiedLeads': value['verifiedLeads'],
        'ordersNet': value['ordersNet'],
        'ordersGross': value['ordersGross'],
        'turnoverNet': MoneyOutputToJSON(value['turnoverNet']),
        'turnoverGross': MoneyOutputToJSON(value['turnoverGross']),
        'spendGoodsNet': MoneyOutputToJSON(value['spendGoodsNet']),
        'spendGoodsGross': MoneyOutputToJSON(value['spendGoodsGross']),
        'spendMarketing': MoneyOutputToJSON(value['spendMarketing']),
        'clicks': value['clicks'],
        'impressions': value['impressions'],
        'remoteId': value['remoteId'],
        'name': value['name'],
        'integrationName': value['integrationName'],
        'statusName': value['statusName'],
        'performanceSegmentGross': value['performanceSegmentGross'],
        'status': value['status'],
    };
}

